import * as React from "react";
import "../assets/style/main.less";
import { AppRouter, Redirect, RouteInterceptor, HistoryType } from "@netless/i18n-react-router";
import { language } from "../locale";
import PortalLayout from "./PortalLayout";
import Login from "../components/user/Login";
import EmailAccountVerification from "../components/user/EmailAccountVerification";
import EmailAccountVerificationStepTwo from "../components/user/EmailAccountVerificationStepTwo";
import ResetPassword from "../components/user/ResetPassword";
import Register from "../components/user/Register";
import RegisterStepTwo from "../components/user/RegisterStepTwo";
import RegisterStepThree from "../components/user/RegisterStepThree";
import RegisterStepUpdateInf from "../components/user/RegisterStepUpdateInf";

// ServiceCenter
import SelectStorageDriver from "../components/portal/driverComponents/SelectStorageDriver";

// UserCenter
import AddStorageDriver from "../components/portal/driverComponents/AddStorageDriver";
import Dashboard from "../components/portal/dashboard/Dashboard";
import { miniPersistStore } from "../models/MiniPersistStore";
import {ConfigProvider, message} from "antd";
import DebugReplay from "../components/portal/debugCenter/DebugReplay";
import DebugRoom from "../components/portal/debugCenter/DebugRoom";
import WhiteboardData from "../components/portal/dataCenter/WhiteboardData";
import StaticConversionData from "../components/portal/dataCenter/StaticConversionData";
import DynamicConversionData from "../components/portal/dataCenter/DynamicConversionData";
import DosageReport from "src/components/portal/dataCenter/DosageReport";
import LogSearch from "src/components/portal/logSearch/LogSearch";
import FinancePay from "src/components/portal/finance/FinancePay";
import FinanceBill from "src/components/portal/finance/FinanceBill";
import FinanceInvoice from "src/components/portal/finance/FinanceInvoice";
import FinanceInvoiceSet from "src/components/portal/finance/FinanceInvoiceSet";
import UserCenter from "src/components/portal/userCenter/UserCenter";
import Projects from "src/components/portal/serviceCenter/Projects";
import LogSearchDetail from "src/components/portal/logSearch/LogSearchDetail";
import ProjectDetail from "src/components/portal/serviceCenter/ProjectDetail";
import StorageDriver from "../components/portal/userCenter/StorageDriver";
import FinanceInvoiceAddress from "../components/portal/finance/FinanceInvoiceAddress";
import zhCN from "antd/es/locale/zh_CN";
import ProjectDetailDelete from "../components/portal/serviceCenter/ProjectDetailDelete";


const portalInterceptor: RouteInterceptor = (props, Component) => {
    if (miniPersistStore.token && miniPersistStore.adminEnable === "true") {
        if (props.location.pathname === "/zh-CN/register/update-inf/" || props.location.pathname === "/en/register/update-inf/") {
            return <Component {...props} />;
        } else {
            return (
                <PortalLayout>
                    <Component {...props} />
                </PortalLayout>
            );
        }
    } else {
        return <Redirect to={`/login/`} />;
    }
};

export class AppRoutes extends React.Component<{}, {}> {

    public constructor(props: {}) {
        super(props);
    }
    public componentDidCatch(error: any, inf: any): void {
        miniPersistStore.token = "";
        message.info(`网页加载发生错误：${error}`);
    }
    public render(): React.ReactNode {
        return (
            <ConfigProvider locale={zhCN}>
                <AppRouter historyType={HistoryType.BrowserRouter} language={language} routes={[
                    // // projects
                    // { path: "/projects/", component: Projects, interceptor: portalInterceptor },
                    // { path: "/projects/:uuid/", component: ProjectDetail, interceptor: portalInterceptor },
                    // { path: "/projects/delete/:uuid/", component: ProjectDetailDelete, interceptor: portalInterceptor },

                    // log
                    { path: "/log/", component: LogSearch, interceptor: portalInterceptor },
                    { path: "/log/:uuid/:startTime/", component: LogSearchDetail, interceptor: portalInterceptor },


                    // // user-center
                    { path: "/user-center/info/", component: UserCenter, interceptor: portalInterceptor },
                    // { path: "/user-center/driver/", component: StorageDriver, interceptor: portalInterceptor },
                    // { path: "/user-center/driver/select-storage-driver/", component: SelectStorageDriver, interceptor: portalInterceptor},
                    // { path: "/user-center/driver/select-storage-driver/add-storage-driver/:provider/:storageId?/", component: AddStorageDriver, interceptor: portalInterceptor },
                    // { path: "/user-center/driver/add-storage-driver/:provider/:storageId?/", component: AddStorageDriver, interceptor: portalInterceptor },

                    // user-login
                    { path: "/login/", component: Login },
                    { path: "/email-account-verification/:tab?/", component: EmailAccountVerification },
                    { path: "/email-account-verification-step-two/:tab?/", component: EmailAccountVerificationStepTwo },
                    // { path: "/register/", component: Register },
                    // { path: "/register/step-two/:tab?/", component: RegisterStepTwo },
                    // { path: "/register/step-three/", component: RegisterStepThree },
                    // { path: "/register/update-inf/", component: RegisterStepUpdateInf, interceptor: portalInterceptor },
                    { path: "/reset-password/", component: ResetPassword },
                    { path: "/", component: Dashboard, interceptor: portalInterceptor },

                    // // finance
                    // { path: "/finance/pay/", component: FinancePay, interceptor: portalInterceptor },
                    { path: "/finance/bill/", component: FinanceBill, interceptor: portalInterceptor },
                    // { path: "/finance/invoice/", component: FinanceInvoice, interceptor: portalInterceptor },
                    // { path: "/finance/invoice/set/", component: FinanceInvoiceSet, interceptor: portalInterceptor },
                    // { path: "/finance/invoice/address/", component: FinanceInvoiceAddress, interceptor: portalInterceptor },

                    // user-debug
                    { path: "/debug-center/replay/:uuid?/:roomToken?/", component: DebugReplay, interceptor: portalInterceptor },
                    { path: "/debug-center/room/:uuid?/:roomToken?/", component: DebugRoom, interceptor: portalInterceptor },

                    // data
                    { path: "/data/report/", component: DosageReport, interceptor: portalInterceptor },
                    { path: "/data/whiteboard/", component: WhiteboardData, interceptor: portalInterceptor },
                    { path: "/data/static-conversion/", component: StaticConversionData, interceptor: portalInterceptor },
                    { path: "/data/dynamic-conversion/", component: DynamicConversionData, interceptor: portalInterceptor },
                ]} />
            </ConfigProvider>
        );
    }
}




// WEBPACK FOOTER //
// ./src/pages/AppRoutes.tsx